import React from 'react';
import OptimizeSchedulePanel from './OptimizeSchedulePanel';

/** Schedules → Neighbours Scan Schedule: the site's scheduled neighbours scans. */
export default function NeighborScanSchedulePanel(props) {
  return <OptimizeSchedulePanel kind="neighbor_scan" {...props} />;
}
